import { type SectionFilterConfig } from "@/configuration/types";
import { isReferralRecordClassification } from "@/src/models/constants/classifications";
import { File } from "@/src/models/file";
import { Section, SectionStatus } from "@/src/models/section";

/**
 * Filters sections based on their status and group-specific rules from SectionFilterConfig.
 *
 * @param file - File containing sections to filter
 * @param config - Group-specific section filter configuration (from useSectionFilterConfig hook)
 * @param shouldConsiderNonExtract - Whether to consider non-extract sections (default: false)
 * @returns Filtered array of sections
 */
export function filterSections(
  file: File | undefined,
  config: SectionFilterConfig | undefined,
  shouldConsiderNonExtract: boolean = false
): Section[] {
  if (!file) return [];

  const sections = file.sections.filter((section) => {
    if (shouldConsiderNonExtract && config?.considerNonExtractSections) {
      return true;
    }

    return section.status !== SectionStatus.NO_EXTRACT;
  });

  const hasReferralSection = sections.some((section) => isReferralRecordClassification(section.classification));

  if (!hasReferralSection || !config?.referralRelatedClassifications) {
    return sections;
  }

  const referralSet = new Set(config.referralRelatedClassifications);

  return sections.filter((section) => referralSet.has(section.classification));
}
